import { useMutation } from '@apollo/client';
import { useEffect } from 'react';
import {
  UPDATE_PRODUCTS,
  SET_ATTR,
  SET_PROMO_CODE_APPLIED,
  useOrder,
} from '../../hooks/useOrder';
import { APPLY_PROMO_CODE_TO_ORDER } from '../../mutations';
import ErrorText from '../ErrorText';
import LoadingSpinner from '../LoadingSpinner';
import PromoCodeForm from './PromoCodeForm';
import { isStripePaymentRequired } from '../../utils/featureFlags';

export default function PromoCodeForOrders({ className }) {
  const { state, dispatch } = useOrder();
  const { orderDetails, promoCodeApplied } = state;
  const { orderId } = orderDetails;

  const [
    applyPromoCodeToOrder,
    { loading, error, data: dataApplyPromoCodeToOrder },
  ] = useMutation(APPLY_PROMO_CODE_TO_ORDER);

  function handleSubmit(data) {
    applyPromoCodeToOrder({
      variables: {
        orderId,
        promoCode: data.promoCode,
      },
    });
  }

  useEffect(() => {
    dispatch({
      type: SET_ATTR,
      payload: {
        name: 'loadingApplyPromoCode',
        value: loading,
      },
    });
  }, [dispatch, loading]);

  useEffect(() => {
    dispatch({
      type: SET_ATTR,
      payload: {
        name: 'errorApplyPromoCode',
        value: error,
      },
    });
  }, [dispatch, error]);

  useEffect(() => {
    const discountedInvoice =
      dataApplyPromoCodeToOrder?.applyPromoCodeToOrder?.invoice;
    if (discountedInvoice) {
      const lineItems = discountedInvoice.lineItems;
      dispatch({
        type: UPDATE_PRODUCTS,
        payload: {
          lineItems,
          totalPrice: discountedInvoice.total,
        },
      });
      dispatch({
        type: SET_PROMO_CODE_APPLIED,
        payload: {
          ...discountedInvoice.discount,
          code: dataApplyPromoCodeToOrder.applyPromoCodeToOrder?.promoCode,
        },
      });
    }
  }, [dataApplyPromoCodeToOrder, dispatch]);

  return (
    <>
      {isStripePaymentRequired() && (
        <div className={`flex flex-col ${className ? className : ''}`}>
          {loading && (
            <LoadingSpinner message="Applying promo code..." className="ml-0" />
          )}
          {!loading && (
            <PromoCodeForm
              onSubmit={handleSubmit}
              promoCodeApplied={promoCodeApplied}
            />
          )}
          {error && <ErrorText message={error.message} className="ml-0" />}
        </div>
      )}
    </>
  );
}
